﻿import React, { useRef } from 'react';
import classNames from 'classnames';
import { FileInput } from "@blueprintjs/core";
import PropTypes from 'prop-types';

import { FormHelperText, FormHeading } from "components/form-fields";

import 'components/form-fields/FormFields.css';

export function FormFileInput(
    {
        id = null,
        loading = false,
        headingText = "",
        helperText = null,
        disabled = false,
        dangerHelperText = null,
        fill = true,
        hasSelection = false,
        resetOnSelect = false,
        acceptedMimeTypes,
        buttonText,
        label,
        onChange,
        text
    }
) {
	const fileRef = useRef(null);

	function onInputChange(e) {
		onChange(e);

		if (resetOnSelect && fileRef && fileRef.current) {
			fileRef.current.value = "";
		}
	}

	return (
        <div className={classNames("form-field form-field-fileinput", { "no-label": !label })}>
            <FormHeading loading={loading} headingLevel={"h4"}>{headingText}</FormHeading>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <FileInput
				id={id}
				disabled={disabled}
				className={classNames({ "bp6-skeleton": loading })}
				onInputChange={onInputChange}
				buttonText={buttonText}
				fill={fill}
				text={text}
				hasSelection={hasSelection}
				inputProps={{ 
					accept: acceptedMimeTypes ? acceptedMimeTypes.join(",") : undefined, 
					ref: fileRef 
				}}
			/>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormFileInput.propTypes = {
	id: PropTypes.string,
	text: PropTypes.string,
	fill: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	headingText: PropTypes.string,
	helperText: PropTypes.node,
	disabled: PropTypes.bool,
	dangerHelperText: PropTypes.node,
	buttonText: PropTypes.string,
	hasSelection: PropTypes.bool,
	acceptedMimeTypes: PropTypes.arrayOf(PropTypes.string),
	resetOnSelect: PropTypes.bool
};